import { NgModule } from '@angular/core';
import { ThemeComponent } from './theme.component';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from "../auth/_guards/auth.guard";
import { ApiService } from './pages/api-service.service';
import { webConfig } from '../webconfig';


const routes: Routes = [
    {
        "path": "",
        "component": ThemeComponent,
        "canActivate": [AuthGuard],
        "children": [
            // {
            //     "path": "index",
            //     "loadChildren": ".\/pages\/subheader-type-search\/index\/index.module#IndexModule"
            // },
            {
                "path": "Predict-Model",
                "loadChildren": ".\/pages\/default\/inner\/inner.module#InnerModule"
            },
            {
                "path": "404",
                "loadChildren": ".\/pages\/default\/not-found\/not-found.module#NotFoundModule"
            },
            {
                "path": "Loan-Predict",
                "loadChildren": ".\/pages\/default\/blank\/blank.module#BlankModule"
            },
            {
                "path": "Loan-Insight",
                "loadChildren": ".\/pages\/default\/deposit-position\/deposit-position.module#DepositPositionModule"
            },
            {
                "path": "Administration",
                "loadChildren": ".\/pages\/default\/loan-prov\/loan-prov.module#LoanProvModule"
            },
            {
                "path": "",
                "redirectTo": "Predict-Model",
                "pathMatch": "full"
            }
        ]
    },
    {
        "path": "**",
        "redirectTo": "404",
        "pathMatch": "full"
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [ApiService,webConfig],
})
export class ThemeRoutingModule { }


// WEBPACK FOOTER //
// D:/Finca/Finca UI/UI/src/app/theme/theme-routing.module.ts